// import { Link } from "react-router-dom";
// import { Logo, ProfileImg } from "../../assets/images";

// const Header = () => {
//     const openSidebar = () => {
//         document.body.classList.add("sidebar-open");
//     };
//     return (
//         <header className="main-header d-flex">
//             <div className="logo-header">
//                 <Link to="/" className="logo">
//                     <img src={Logo} alt="Logo" />
//                 </Link>
//             </div>
//             <div className="header-right d-flex gap-2 w-100">
//                 <button className="bar-button" onClick={openSidebar}>
//                     <i className="icon-icon-29"></i>
//                 </button>
//                 <div className="dropdown profile-dropdown ms-auto">
//                     <button className="dropdown-toggle p-0" type="button" id="profileDrodown" data-bs-toggle="dropdown" aria-expanded="false">
//                         <div className="profile d-flex align-items-center">
//                             <div className="profile-pic">
//                                 <img src={ProfileImg} alt="Profile" />
//                             </div>
//                             <div className="profile-info">
//                                 <span className="profile-name d-block">John Doe</span>
//                                 <span className="profile-role d-block">Admin</span>
//                             </div>
//                         </div>
//                     </button>
//                     <ul className="dropdown-menu" aria-labelledby="profileDrodown">
//                         <li><Link className="dropdown-item" to="#">My Profile</Link></li>
//                         <li><Link className="dropdown-item" to="#">Change Password</Link></li>
//                         <li><button className="dropdown-item" to="#">Sign Out</button></li>
//                     </ul>
//                 </div>
//             </div>
//         </header>
//     )
// }

// export default Header;

import { Link, useNavigate } from "react-router-dom";
import { Logo, ProfileImg } from "../../assets/images";
import { useEffect, useState } from "react";
import axios from "axios";

const Header = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const refreshUser = () => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
  };

  useEffect(() => {
    refreshUser();
    window.addEventListener("userProfileUpdated", refreshUser);
    return () => window.removeEventListener("userProfileUpdated", refreshUser);
  }, []);

  const openSidebar = () => {
    document.body.classList.add("sidebar-open");
  };

  const getRole = (level) => {
    if (level === 1) return "Admin";
    if (level === 2) return "Sub Admin";
    return "User";
  };

  const handleLogout = async () => {
    try {
      // Call logout API with token
      const token = user?.token;
      await axios.post(
        `${process.env.REACT_APP_API_URL}auth/logout`, // 🔹 replace with your actual API route
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Clear user from localStorage
      localStorage.removeItem("user");

      // Redirect to login
      navigate("/login");
    } catch (error) {
      console.error("Logout failed", error);
      // Still clear local storage in case of error
      localStorage.removeItem("user");
      navigate("/login");
    }
  };

  return (
    <header className="main-header d-flex">
      <div className="logo-header">
        <Link to="/" className="logo">
          <img src={Logo} alt="Logo" />
        </Link>
      </div>
      <div className="header-right d-flex gap-2 w-100">
        <button className="bar-button" onClick={openSidebar}>
          <i className="icon-icon-29"></i>
        </button>
        <div className="dropdown profile-dropdown ms-auto">
          <button
            className="dropdown-toggle p-0"
            type="button"
            id="profileDrodown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <div className="profile d-flex align-items-center">
              <div className="profile-pic">
                <img
                  src={
                    user?.profile_picture
                      ? `${process.env.REACT_APP_API_URL.replace(/\/v1\/$/, "")}${user.profile_picture}`
                      : ProfileImg
                  }
                  alt="Profile"
                />
              </div>
              <div className="profile-info">
                <span className="profile-name d-block">
                  {user?.name || "Guest"}
                </span>
                <span className="profile-role d-block">
                  {getRole(user?.access_level)}
                </span>
              </div>
            </div>
          </button>
          <ul className="dropdown-menu" aria-labelledby="profileDrodown">
            <li>
              <Link className="dropdown-item" to="/my-profile">
                My Profile
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/change-password">
                Change Password
              </Link>
            </li>
            <li>
              <button className="dropdown-item" onClick={handleLogout}>
                Sign Out
              </button>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;